'use client';

import Link from 'next/link';
import CustomImage from '@/components/ui/CustomImage';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div className="w-full h-full flex flex-col items-center justify-center min-h-screen p-6 gap-5">
      <CustomImage
        src="/images/logos/logo.png"
        alt="Zangia.mn"
        width={324}
        height={76}
      />
      <h2 className="text-xl font-bold mb-4">
        Уучлаарай,Системийн алдаа гарлаа!
      </h2>
      <p className="text-gray-600 mb-6">{error.message}</p>

      <button
        onClick={() => {
          if (
            error.name === 'ChunkLoadError' ||
            error.message.includes('Loading chunk') ||
            error.message.includes(
              'Failed to fetch dynamically imported module'
            )
          ) {
            const hasReloaded = sessionStorage?.getItem('hasReloaded');
            if (!hasReloaded) {
              sessionStorage?.setItem('hasReloaded', 'true');
              window.location.reload(); // Docker container-аас шинэ chunk татах
            }
          } else if (error.message.includes('ChunkLoadError')) {
            window.location.reload();
          } else {
            reset();
          }
        }}
        className="w-[300px] max-w-full h-12 flex items-center justify-center bg-primary-600 text-white px-4 py-2 rounded-lg shadow"
      >
        Дахин оролдох
      </button>
      <Link
        href="/"
        className="w-[300px] h-12 items-center justify-center bg-gray-200 text-gray-800 px-4 py-2 rounded-lg shadow hidden sm:flex"
      >
        Нүүр хуудас руу буцах
      </Link>
    </div>
  );
}
